import numeral from 'numeral';

function formatPrice(value) {
  return numeral(value).format('$0,0.00');
}


/**
 *
 * @param {object} address
 */
function addressFromPb(address) {
  let formatted = {
    address: address.addressLines[0],
    address2: address.addressLines[1] || '',
    city: address.cityTown,
    province: address.stateProvince,
    postal_code: address.postalCode,
    country: address.countryCode || 'US',
  };

  if(!formatted.country) {
    formatted.country = 'US';
  }

  return formatted;
}

/**
 *
 * @param {object} address
 */
function addressToPb(address) {
  let formatted = {
    addressLines: [address.address, address.address2],
    cityTown: address.city,
    stateProvince: address.province,
    postalCode: address.postal_code || address.postal,
    countryCode: address.country || 'US'
  };

  if (address.first_name && address.last_name) {
    formatted.name = address.first_name + ' ' + address.last_name;
  }

  if(!formatted.countryCode) {
    formatted.countryCode = 'US';
  }

  return formatted;
}

function addressOneLine(address) {
  return Object.values(address).join(', ');
}

function addressPretty(address) {
  return `${address.address}, <wbr>${address.city}, <wbr>
  <span v-if="address.province">
    ${address.province}, <wbr>
  </span>
  ${address.country}, <wbr>${address.postal_code}`
}

function errorResponse(response) {
  let err = '';

  if(response.response && response.response.data) {
    response = response.response.data;
  }

  let errors = [];
  if (_.isObject(response.errors) && Object.values(response.errors).length > 0) {
    errors = _.filter(Object.values(response.errors));
  }

  if(response.message) {
    err += response.message;

    if (errors.length > 0) {
      err += ': ';
    }
  }

  if (errors.length > 0) {
    err += errorsComma(response.errors);
  }

  return err;
}

/**
 *
 * @param {Object} errors
 */
function errorsComma(errors) {
  return _.filter(Object.values(errors)).join(', ');
}

export default {
  price: formatPrice,
  formatPrice: formatPrice,

  date: (date) => {
    return moment.utc(date).local().format('lll')
  },

  address: {
    fromPb: addressFromPb,
    toPb: addressToPb,
    oneLine: addressOneLine,
    pretty: addressPretty
  },

  errors: {
    comma: errorsComma,
    fromResponse: errorResponse,
  },

  tracking: {
    status: {
      fromPb: (status) => {
        switch(status) {
          case 'Manifest':
          case 'NotFound':
            return 'label_created';

          case 'InTransit':
          case 'OutForDelivery':
            return 'in_transit';

          case 'Delivered':
            return 'delivered';

          case 'Undelivered':
            return 'undelivered';
          case 'Exception':
            return 'exception';
        }
        return 'label_created';
      },
      label: (status) => {
        switch(status) {
          case 'label_created':
            return 'Label Created';
          case 'in_transit':
            return 'In Transit';
          case 'delivered':
            return 'Delivered';
          case 'undelivered':
            return 'Undelivered';
          case 'exception':
            return 'Exception';
        }
        return null;
      }
    }
  },
};


// WEBPACK FOOTER //
// ./resources/assets/js/formatters/index.js